import { render, staticRenderFns } from "./TestBuyerTopbar.vue?vue&type=template&id=45d27527"
import script from "./TestBuyerTopbar.vue?vue&type=script&lang=js"
export * from "./TestBuyerTopbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports